import { WindowLocation } from './window-location';

export const setUrlSearchParam = (paramName: string, paramValue: string) => {
    const url = new URL(WindowLocation.getHref());
    url.searchParams.set(paramName, paramValue);
    history.replaceState({}, '', url.href);
};
